import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import {
  clearImpersonation,
  getImpersonation,
} from "../../lib/impersonation";
import { useAuth } from "../../context/AuthContext";

export default function ImpersonationBanner() {
  const [imp, setImp] = useState(() => getImpersonation());
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const handler = () => setImp(getImpersonation());
    window.addEventListener("kb-imp-changed", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("kb-imp-changed", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  if (!imp || !imp.sellerUserId) return null;

  const exit = async () => {
    try {
      if (imp.sessionId) {
        await api.post("/admin/sellers/impersonate/stop", { session_id: imp.sessionId });
      }
    } catch {
      /* idempotent — still clear locally */
    }
    clearImpersonation();
    toast.success("Exited impersonation");
    await refresh();
    navigate("/admin/sellers");
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-50 w-full bg-amber-500 text-black border-b border-amber-700"
    >
      <div className="px-4 md:px-8 py-2 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <UserCheck size={16} />
          <span className="truncate">
            Acting as seller <b>{imp.shopName || imp.shopSlug}</b>
          </span>
        </div>
        <button
          onClick={exit}
          data-testid="impersonation-exit-btn"
          className="inline-flex items-center gap-2 bg-black/80 text-white px-3 py-1.5 rounded-sm text-xs hover:bg-black"
        >
          <LogOut size={14} /> Exit
        </button>
      </div>
    </div>
  );
}
